import React, { useMemo } from 'react';
import cx from 'clsx';

import { IconSystemBadge } from '@/assets/icon/avatar';

import style from './index.module.scss';

export interface SystemAccountAvatarProps {
  data?: SystemAccount;
  size?: number;
  className?: string;
  onClick?(): void;
  logoVisible?: boolean;
  logoSize?: number;
}

export const SystemAccountAvatar = ({
  data,
  size = 100,
  className,
  onClick,
  logoVisible = true,
  logoSize = 18,
}: SystemAccountAvatarProps) => {
  const avatar = data?.logo_thumbnail_url || data?.logo_url;

  const logoSizeStyle = useMemo(() => ({ width: logoSize, height: logoSize }), [logoSize]);
  const avatarSizeStyle = useMemo(() => ({ width: size, height: size }), [size]);

  return (
    <div className={cx(style.systemAccountAvatar, className)} onClick={onClick}>
      {logoVisible ? <IconSystemBadge className={style.logo} style={logoSizeStyle} /> : null}
      <div className={style.avatar} style={avatarSizeStyle}>
        {!!avatar && <img src={avatar} className={style.avatarLogo} alt="" />}
      </div>
    </div>
  );
};
